import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { NoDataFoundImage, NOMessageIcon } from "../../assets/Icon/NodataImage";
import CustomButton from "./CustomButton";
import { fontSize, fontWeight } from "@mui/system";
import Image from "../../assets/Images/InvoiceNoData.svg";

interface nodataPropsTypes {
  title?: string;
  subTitle?: string;
  isMessage?: boolean;
  handleData?: () => void;
  buttonTitle?: string;
  status?: boolean;
}
const NoDataFound = (props: nodataPropsTypes) => {
  const { title, subTitle, isMessage, buttonTitle, handleData, status } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // console.log(buttonTitle,"buttonTitle");
  return (
    <Box
      sx={{
        background: "white",
        paddingY: isMobile ? "40px" : "86px",
        paddingX: isMobile ? "10px" : 0,
        textAlign: "center",
        display: "grid",
        justifyItems: "center",
        boxShadow: `
          0px 1px 2px 0px #00000005,
          0px 3px 3px 0px #00000005,
          0px 7px 4px 0px #00000003,
          0px 12px 5px 0px #00000000,
          0px 18px 5px 0px #00000000
        `,
        borderRadius: "10px",
        width: isMobile ? "100%" : undefined,
        maxWidth: isMobile ? "100%" : "unset",
      }}
    >
      {/* {isMessage ? <NOMessageIcon /> : <NoDataFoundImage />} */}
      {buttonTitle ? (
        <img
          src={Image}
          alt="no-data-img"
          style={{ width: isMobile ? "140px" : "228px", maxWidth: "100%" }}
        />
      ) : isMessage ? (
        <NOMessageIcon />
      ) : (
        <NoDataFoundImage />
      )}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: isMobile ? "18px" : "28px",
          lineHeight: isMobile ? "28px" : "46px",
          color: "#05000B",
          paddingTop: 2,
          paddingBottom: isMessage ? 0 : 1,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: isMobile ? "12px" : "16px",
          lineHeight: isMobile ? "18px" : "28px",
          color: "#6C6F71",
          paddingBottom: 2,
          width: isMobile ? "100%" : "500px",
          maxWidth: "100%",
          textAlign: "center",
          p: 0,
        }}
      >
        {status
          ? subTitle
          : "User not submitted the documents yet. You need to wait until the user submit the documents."}
      </Typography>
      {status && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
            width: isMobile ? "100%" : "auto",
          }}
        >
          <Button
            type="submit"
            sx={{
              width: isMobile ? "100%" : "191px",
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: 600,
              color: "#fff",
              padding: isMobile ? "12px 10px" : "16px 20px",
              height: isMobile ? "44px" : "52px",
              background:
                " linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
            }}
            onClick={handleData}
            // loading={loading}
          >
            {buttonTitle?.length ? buttonTitle : "Start Now"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default NoDataFound;
